import useInspireOptions from './useInspireOptions';

export enum ClickstreamTypes {
  Button = 'button',
  Link = 'link',
  Element = 'element',
  Select = 'select',
  Tab = 'tab',
  Checkbox = 'checkbox',
  Icon = 'icon',
  Toggle = 'toggle',
  Widget = 'widget',
}

interface UseClickstreamTags {
  slotId: string;
  type: ClickstreamTypes;
  action: string;
  feature?: string;
  contentId?: string;
  [key: string]: string | number | boolean | undefined;
}

export const useClickstreamTags = ({
  type,
  feature,
  action,
  slotId,
  contentId,
  ...rest
}: UseClickstreamTags) => {
  const { requesterUserID, requesterUsername, isTm, isOm } =
    useInspireOptions();

  return {
    'data-csa-c-slot-id': slotId,
    'data-csa-c-type': type,
    'data-csa-c-tag2': feature,
    'data-csa-c-tag3': action,
    'data-csa-c-profile-id': requesterUserID,
    'data-csa-c-username': requesterUsername,
    'data-csa-c-is-tm': isTm,
    'data-csa-c-is-om': isOm,
    ...(contentId && { 'data-csa-c-content-id': contentId }),
    ...rest,
  };
};
